(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[834],{

/***/ 6834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ autosuggest; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/utils/utils.js
var isGroup = function(option) {
    return "type" in option && option.type === "parent";
};
var popLastGroup = function(options) {
    if (options.length) {
        var lastOption = options[options.length - 1];
        if (isGroup(lastOption)) {
            options.pop();
        }
    }
};
var filterOptions = function(options, text) {
    var filteredOptions = options.reduce(function(filteredIn, option) {
        if (isGroup(option)) {
            popLastGroup(filteredIn);
            filteredIn.push(option);
        } else if (matchSingleOption(option, text)) {
            filteredIn.push(option);
        }
        return filteredIn;
    }, []);
    popLastGroup(filteredOptions);
    return filteredOptions;
};
var matchSingleOption = function(option, text) {
    var searchableFields = [
        "value",
        "label",
        "description",
        "labelTag"
    ];
    var searchableTagFields = [
        "tags",
        "filteringTags"
    ];
    var searchText = text.toLowerCase();
    var searchStrFieldsFn = function(attr) {
        return matchString(option[attr], searchText);
    };
    var searchTagsFieldsFn = function(attr) {
        var _a;
        return (_a = option[attr]) === null || _a === void 0 ? void 0 : _a.some(function(value) {
            return matchString(value, searchText);
        });
    };
    return searchableFields.some(searchStrFieldsFn) || searchableTagFields.some(searchTagsFieldsFn);
};
var matchString = function(value, searchText) {
    return value && value.toLowerCase().indexOf(searchText) !== -1;
}; //# sourceMappingURL=utils.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/test-indexes.js
var test_indexes = __webpack_require__(9720);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/utils/use-highlight-option.js
var use_highlight_option = __webpack_require__(3509);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/options-controller.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var isHighlightable = function(option) {
    return !!option && option.type !== "parent";
};
var parentMap = new WeakMap();
var getParentGroup = function(item) {
    return parentMap.get(item);
};
var isInteractive = function(option) {
    return !!option && !option.disabled && option.type !== "parent";
};
var useAutosuggestItems = function(_a) {
    var options = _a.options, filterValue = _a.filterValue, filterText = _a.filterText, filteringType = _a.filteringType, hideEnteredTextLabel = _a.hideEnteredTextLabel, onSelectItem = _a.onSelectItem;
    var _b = (0,react.useState)(false), showAll = _b[0], setShowAll = _b[1];
    var items = (0,react.useMemo)(function() {
        return createItems(options);
    }, [
        options
    ]);
    var filteredItems = (0,react.useMemo)(function() {
        var filteredItems = filteringType === "auto" && !showAll ? filterOptions(items, filterText) : (0,tslib_es6/* __spreadArray */.ev)([], items, true);
        if (filterValue && !hideEnteredTextLabel) {
            filteredItems.unshift({
                value: filterValue,
                type: "use-entered",
                option: {
                    value: filterValue
                }
            });
        }
        (0,test_indexes/* generateTestIndexes */.$)(filteredItems, getParentGroup);
        return filteredItems;
    }, [
        items,
        filterValue,
        filterText,
        filteringType,
        showAll,
        hideEnteredTextLabel
    ]);
    var _c = (0,use_highlight_option/* useHighlightedOption */.P)({
        options: filteredItems,
        isHighlightable: isHighlightable
    }), highlightedOptionState = _c[0], highlightedOptionHandlers = _c[1];
    var selectHighlightedOptionWithKeyboard = function() {
        if (highlightedOptionState.highlightedOption && isInteractive(highlightedOptionState.highlightedOption)) {
            onSelectItem(highlightedOptionState.highlightedOption);
            return true;
        }
        return false;
    };
    var highlightVisibleOptionWithMouse = function(index) {
        if (filteredItems[index] && isHighlightable(filteredItems[index])) {
            highlightedOptionHandlers.setHighlightedIndexWithMouse(index);
        }
    };
    var selectVisibleOptionWithMouse = function(index) {
        if (filteredItems[index] && isInteractive(filteredItems[index])) {
            onSelectItem(filteredItems[index]);
        }
    };
    return [
        (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, highlightedOptionState), {
            items: filteredItems,
            showAll: showAll
        }),
        (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, highlightedOptionHandlers), {
            setShowAll: setShowAll,
            selectHighlightedOptionWithKeyboard: selectHighlightedOptionWithKeyboard,
            highlightVisibleOptionWithMouse: highlightVisibleOptionWithMouse,
            selectVisibleOptionWithMouse: selectVisibleOptionWithMouse
        })
    ];
};
function createItems(options) {
    var items = [];
    for(var _i = 0, options_1 = options; _i < options_1.length; _i++){
        var option = options_1[_i];
        if (options_controller_isGroup(option)) {
            for(var _a = 0, _b = flattenGroup(option); _a < _b.length; _a++){
                var item = _b[_a];
                items.push(item);
            }
        } else {
            items.push((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, option), {
                option: option
            }));
        }
    }
    return items;
}
function options_controller_isGroup(optionOrGroup) {
    return "options" in optionOrGroup;
}
function flattenGroup(group) {
    var options = group.options, rest = (0,tslib_es6/* __rest */._T)(group, [
        "options"
    ]);
    var hasOnlyDisabledChildren = true;
    var items = [
        (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, rest), {
            type: "parent",
            option: group
        })
    ];
    for(var _i = 0, options_2 = options; _i < options_2.length; _i++){
        var option = options_2[_i];
        if (!option.disabled) {
            hasOnlyDisabledChildren = false;
        }
        var childOption = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, option), {
            type: "child",
            disabled: option.disabled || rest.disabled,
            option: option
        });
        items.push(childOption);
        // TODO: Refactor parentMap and remove this side effect
        parentMap.set(childOption, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, group), {
            option: group
        }));
    }
    items[0].disabled = items[0].disabled || hasOnlyDisabledChildren;
    return items;
} //# sourceMappingURL=options-controller.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-status/index.js + 3 modules
var dropdown_status = __webpack_require__(5094);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown-footer/index.js + 1 modules
var dropdown_footer = __webpack_require__(1550);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-unique-id/index.js
var use_unique_id = __webpack_require__(6081);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/events/index.js
var events = __webpack_require__(6322);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/autosuggest/styles.scoped.css
var styles_scoped = __webpack_require__(8241);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_12hwc_12ujv_5",
    "layout-strut": "awsui_layout-strut_12hwc_12ujv_9",
    "list-bottom": "awsui_list-bottom_12hwc_12ujv_15"
});

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/utils/check-option-value-field.js
var check_option_value_field = __webpack_require__(7073);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/check-controlled/index.js
var check_controlled = __webpack_require__(3686);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/node_modules/react-virtual/dist/react-virtual.mjs
var react_virtual = __webpack_require__(6427);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/options-list/index.js + 1 modules
var options_list = __webpack_require__(7906);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/container-queries/use-container-query.js
var use_container_query = __webpack_require__(5382);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/option/index.js + 3 modules
var components_option = __webpack_require__(3999);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/selectable-item/index.js + 1 modules
var selectable_item = __webpack_require__(1120);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(8312);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/autosuggest-option.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var AutosuggestOption = function(_a, ref) {
    var _b = _a.nativeAttributes, nativeAttributes = _b === void 0 ? {} : _b, highlightText = _a.highlightText, option = _a.option, highlighted = _a.highlighted, highlightType = _a.highlightType, enteredTextLabel = _a.enteredTextLabel, virtualPosition = _a.virtualPosition, padBottom = _a.padBottom, screenReaderContent = _a.screenReaderContent, ariaSetsize = _a.ariaSetsize, ariaPosinset = _a.ariaPosinset, rest = (0,tslib_es6/* __rest */._T)(_a, [
        "nativeAttributes",
        "highlightText",
        "option",
        "highlighted",
        "highlightType",
        "enteredTextLabel",
        "virtualPosition",
        "padBottom",
        "screenReaderContent",
        "ariaSetsize",
        "ariaPosinset"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(rest);
    var useEntered = "type" in option && option.type === "use-entered";
    var isParent = "type" in option && option.type === "parent";
    var isChild = "type" in option && option.type === "child";
    var _c = (0,test_indexes/* getTestOptionIndexes */.w)(option) || {}, throughIndex = _c.throughIndex, inGroupIndex = _c.inGroupIndex, groupIndex = _c.groupIndex;
    var optionContent;
    if (useEntered) {
        optionContent = enteredTextLabel(option.value || "");
    } else if (isParent) {
        optionContent = option.label;
    } else {
        var a11yProperties = {};
        if (nativeAttributes["aria-label"]) {
            a11yProperties["aria-label"] = nativeAttributes["aria-label"];
        }
        optionContent = /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, a11yProperties), /*#__PURE__*/ react.createElement(components_option/* default */.Z, {
            option: option,
            highlightText: highlightText
        }));
    }
    return /*#__PURE__*/ react.createElement(selectable_item/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: styles_css.option,
        ariaSelected: highlighted,
        highlighted: highlighted,
        disabled: option.disabled,
        hasBackground: useEntered,
        isParent: isParent,
        isChild: isChild,
        virtualPosition: virtualPosition,
        "data-test-index": throughIndex,
        "data-in-group-index": inGroupIndex,
        "data-group-index": groupIndex,
        ref: ref,
        padBottom: padBottom,
        screenReaderContent: screenReaderContent,
        ariaSetsize: ariaSetsize,
        ariaPosinset: ariaPosinset,
        highlightType: highlightType
    }), optionContent);
};
/* harmony default export */ var autosuggest_option = (/*#__PURE__*/react.memo(/*#__PURE__*/ react.forwardRef(AutosuggestOption))); //# sourceMappingURL=autosuggest-option.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/scrollable-containers.js
var scrollable_containers = __webpack_require__(764);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/plain-list.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0






var getOptionProps = function(index, item, filteredItems, highlightedA11yProps, highlightedOption, hasDropdownStatus) {
    var nativeAttributes = item === highlightedOption ? highlightedA11yProps : {};
    var baseOptionProps = (0,base_component/* getBaseProps */.j)(nativeAttributes);
    var isLastItem = index === filteredItems.length - 1;
    var isNotEnteredTextItem = filteredItems.length > 1;
    var padBottom = !hasDropdownStatus && isNotEnteredTextItem && isLastItem;
    return (0,tslib_es6/* __assign */.pi)({
        nativeAttributes: nativeAttributes,
        padBottom: padBottom
    }, baseOptionProps);
};
var PlainList = function(_a) {
    var autosuggestItemsState = _a.autosuggestItemsState, handleLoadMore = _a.handleLoadMore, menuProps = _a.menuProps, enteredTextLabel = _a.enteredTextLabel, highlightedA11yProps = _a.highlightedA11yProps, hasDropdownStatus = _a.hasDropdownStatus, highlightText = _a.highlightText, listBottom = _a.listBottom, screenReaderContent = _a.screenReaderContent;
    var listRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _a;
        var item = (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-mouse-target="'.concat(autosuggestItemsState.highlightedIndex, '"]'));
        if (autosuggestItemsState.highlightType === "keyboard" && item) {
            (0,scrollable_containers/* scrollElementIntoView */.bx)(item);
        }
    }, [
        autosuggestItemsState.highlightType,
        autosuggestItemsState.highlightedIndex
    ]);
    return /*#__PURE__*/ react.createElement(options_list/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, menuProps, {
        onLoadMore: handleLoadMore,
        open: true,
        ref: listRef,
        // to prevent closing the list when clicking the scrollbar on IE11
        nativeAttributes: {
            unselectable: "on"
        }
    }), autosuggestItemsState.items.map(function(item, index) {
        var optionProps = getOptionProps(index, item, autosuggestItemsState.items, highlightedA11yProps, autosuggestItemsState.highlightedOption, hasDropdownStatus);
        return /*#__PURE__*/ react.createElement(autosuggest_option, (0,tslib_es6/* __assign */.pi)({
            highlightText: highlightText,
            option: item,
            highlighted: item === autosuggestItemsState.highlightedOption,
            key: index,
            "data-mouse-target": index,
            enteredTextLabel: enteredTextLabel,
            screenReaderContent: screenReaderContent,
            highlightType: autosuggestItemsState.highlightType
        }, optionProps));
    }), listBottom ? /*#__PURE__*/ react.createElement("li", {
        role: "option",
        className: styles_css["list-bottom"]
    }, listBottom) : null);
};
/* harmony default export */ var plain_list = (PlainList); //# sourceMappingURL=plain-list.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/virtual-list.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0







var VirtualList = function(_a) {
    var autosuggestItemsState = _a.autosuggestItemsState, handleLoadMore = _a.handleLoadMore, menuProps = _a.menuProps, enteredTextLabel = _a.enteredTextLabel, highlightedA11yProps = _a.highlightedA11yProps, hasDropdownStatus = _a.hasDropdownStatus, highlightText = _a.highlightText, listBottom = _a.listBottom, screenReaderContent = _a.screenReaderContent;
    var scrollRef = (0,react.useRef)(null);
    // update component, when it gets wider or narrower to reposition items
    var _b = (0,use_container_query/* useContainerQuery */.D)(function(rect) {
        return rect.width;
    }, []), width = _b[0], strutRef = _b[1];
    (0,react.useImperativeHandle)(strutRef, function() {
        return scrollRef.current;
    });
    var rowVirtualizer = (0,react_virtual/* useVirtual */.o)({
        size: autosuggestItemsState.items.length,
        parentRef: scrollRef,
        // estimateSize is a dependency of measurements memo. We update it to force full recalculation
        // when the height of any option could have changed:
        // 1: because the component got resized (width property got updated)
        // 2: becasue the option changed its content (highlightText property controls the highlight and the visibility of hidden tags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        estimateSize: (0,react.useCallback)(function() {
            return 31;
        }, [
            width,
            highlightText
        ]),
        overscan: 5
    });
    (0,react.useEffect)(function() {
        if (autosuggestItemsState.highlightType === "keyboard") {
            rowVirtualizer.scrollToIndex(autosuggestItemsState.highlightedIndex);
        }
    }, [
        autosuggestItemsState.highlightType,
        autosuggestItemsState.highlightedIndex,
        rowVirtualizer
    ]);
    return /*#__PURE__*/ react.createElement(options_list/* default */.Z, (0,tslib_es6/* __assign */.pi)({}, menuProps, {
        onLoadMore: handleLoadMore,
        ref: scrollRef,
        open: true,
        // to prevent closing the list when clicking the scrollbar on IE11
        nativeAttributes: {
            unselectable: "on"
        }
    }), /*#__PURE__*/ react.createElement("div", {
        "aria-hidden": "true",
        key: "total-size",
        className: styles_css["layout-strut"],
        style: {
            height: rowVirtualizer.totalSize + (autosuggestItemsState.items.length === 1 ? 1 : 0)
        }
    }), rowVirtualizer.virtualItems.map(function(virtualRow) {
        var index = virtualRow.index, start = virtualRow.start, measureRef = virtualRow.measureRef;
        var item = autosuggestItemsState.items[index];
        var optionProps = getOptionProps(index, item, autosuggestItemsState.items, highlightedA11yProps, autosuggestItemsState.highlightedOption, hasDropdownStatus);
        return /*#__PURE__*/ react.createElement(autosuggest_option, (0,tslib_es6/* __assign */.pi)({
            key: index,
            ref: measureRef,
            highlightText: highlightText,
            option: item,
            highlighted: item === autosuggestItemsState.highlightedOption,
            "data-mouse-target": index,
            enteredTextLabel: enteredTextLabel,
            virtualPosition: start + (index === 0 ? 1 : 0),
            screenReaderContent: screenReaderContent,
            ariaSetsize: autosuggestItemsState.items.length,
            ariaPosinset: index + 1,
            highlightType: autosuggestItemsState.highlightType
        }, optionProps));
    }), listBottom ? /*#__PURE__*/ react.createElement("li", {
        role: "option",
        className: styles_css["list-bottom"]
    }, listBottom) : null);
};
/* harmony default export */ var virtual_list = (VirtualList); //# sourceMappingURL=virtual-list.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/select/utils/use-announcement.js + 1 modules
var use_announcement = __webpack_require__(3517);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/options-list.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var createMouseEventHandler = function(handler) {
    return function(itemIndex) {
        // prevent mouse events to avoid losing focus from the input
        if (itemIndex > -1) {
            handler(itemIndex);
        }
    };
};
function AutosuggestOptionsList(_a) {
    var autosuggestItemsState = _a.autosuggestItemsState, autosuggestItemsHandlers = _a.autosuggestItemsHandlers, highlightedOptionId = _a.highlightedOptionId, highlightText = _a.highlightText, listId = _a.listId, controlId = _a.controlId, enteredTextLabel = _a.enteredTextLabel, handleLoadMore = _a.handleLoadMore, hasDropdownStatus = _a.hasDropdownStatus, virtualScroll = _a.virtualScroll, selectedAriaLabel = _a.selectedAriaLabel, renderHighlightedAriaLive = _a.renderHighlightedAriaLive, listBottom = _a.listBottom;
    var handleMouseUp = createMouseEventHandler(autosuggestItemsHandlers.selectVisibleOptionWithMouse);
    var handleMouseMove = createMouseEventHandler(autosuggestItemsHandlers.highlightVisibleOptionWithMouse);
    var ListComponent = virtualScroll ? virtual_list : plain_list;
    var announcement = (0,use_announcement/* useAnnouncement */.q)({
        announceSelected: true,
        highlightedOption: autosuggestItemsState.highlightedOption,
        getParent: function(option) {
            var _a;
            return (_a = getParentGroup(option)) === null || _a === void 0 ? void 0 : _a.option;
        },
        selectedAriaLabel: selectedAriaLabel,
        renderHighlightedAriaLive: renderHighlightedAriaLive
    });
    return /*#__PURE__*/ react.createElement(ListComponent, {
        listBottom: listBottom,
        handleLoadMore: handleLoadMore,
        autosuggestItemsState: autosuggestItemsState,
        highlightText: highlightText,
        enteredTextLabel: enteredTextLabel,
        highlightedA11yProps: highlightedOptionId ? {
            id: highlightedOptionId
        } : {},
        hasDropdownStatus: hasDropdownStatus,
        menuProps: {
            id: listId,
            ariaLabelledby: controlId,
            onMouseUp: handleMouseUp,
            onMouseMove: handleMouseMove
        },
        screenReaderContent: announcement
    });
} //# sourceMappingURL=options-list.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/load-more-controller.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var useAutosuggestLoadMore = function(_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, statusType = _a.statusType, onLoadItems = _a.onLoadItems;
    var lastFilteringText = (0,react.useRef)(null);
    var fireLoadMore = function(_a) {
        var _b;
        var firstPage = _a.firstPage, samePage = _a.samePage, filteringText = _a.filteringText;
        if (filteringText === undefined || lastFilteringText.current !== filteringText) {
            if (filteringText !== undefined) {
                lastFilteringText.current = filteringText;
            }
            onLoadItems({
                filteringText: (_b = lastFilteringText.current) !== null && _b !== void 0 ? _b : "",
                firstPage: firstPage,
                samePage: samePage
            });
        }
    };
    var fireLoadMoreOnScroll = function() {
        options.length > 0 && statusType === "pending" && fireLoadMore({
            firstPage: false,
            samePage: false
        });
    };
    var fireLoadMoreOnRecoveryClick = function() {
        return fireLoadMore({
            firstPage: false,
            samePage: true
        });
    };
    var fireLoadMoreOnInputFocus = function() {
        return fireLoadMore({
            firstPage: true,
            samePage: false,
            filteringText: ""
        });
    };
    var fireLoadMoreOnInputChange = function(filteringText) {
        return fireLoadMore({
            firstPage: true,
            samePage: false,
            filteringText: filteringText
        });
    };
    return {
        fireLoadMoreOnScroll: fireLoadMoreOnScroll,
        fireLoadMoreOnRecoveryClick: fireLoadMoreOnRecoveryClick,
        fireLoadMoreOnInputFocus: fireLoadMoreOnInputFocus,
        fireLoadMoreOnInputChange: fireLoadMoreOnInputChange
    };
}; //# sourceMappingURL=load-more-controller.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/dropdown/index.js + 2 modules
var dropdown = __webpack_require__(5730);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/context/form-field-context.js
var form_field_context = __webpack_require__(2308);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/input/internal.js
var internal = __webpack_require__(6640);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/keycode.js
var keycode = __webpack_require__(6221);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/components/autosuggest-input/styles.scoped.css
var autosuggest_input_styles_scoped = __webpack_require__(3426);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/autosuggest-input/styles.css.js

/* harmony default export */ var autosuggest_input_styles_css = ({
    "dropdown-footer": "awsui_dropdown-footer_vm8qf_jxdvh_5",
    "dropdown-content": "awsui_dropdown-content_vm8qf_jxdvh_10"
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/internal/components/autosuggest-input/index.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0










var AutosuggestInput = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, name = _a.name, placeholder = _a.placeholder, disabled = _a.disabled, readOnly = _a.readOnly, autoFocus = _a.autoFocus, ariaLabel = _a.ariaLabel, ariaRequired = _a.ariaRequired, _b = _a.disableBrowserAutocorrect, disableBrowserAutocorrect = _b === void 0 ? false : _b, expandToViewport = _a.expandToViewport, ariaControls = _a.ariaControls, ariaActivedescendant = _a.ariaActivedescendant, _c = _a.dropdownExpanded, dropdownExpanded = _c === void 0 ? true : _c, dropdownContentKey = _a.dropdownContentKey, _d = _a.dropdownContentFocusable, dropdownContentFocusable = _d === void 0 ? false : _d, _e = _a.dropdownContent, dropdownContent = _e === void 0 ? null : _e, _f = _a.dropdownFooter, dropdownFooter = _f === void 0 ? null : _f, dropdownWidth = _a.dropdownWidth, loopFocus = _a.loopFocus, onCloseDropdown = _a.onCloseDropdown, onDelayedInput = _a.onDelayedInput, onPressArrowDown = _a.onPressArrowDown, onPressArrowUp = _a.onPressArrowUp, onPressEnter = _a.onPressEnter, __internalRootRef = _a.__internalRootRef, restProps = (0,tslib_es6/* __rest */._T)(_a, [
        "value",
        "onChange",
        "onBlur",
        "onFocus",
        "onKeyUp",
        "onKeyDown",
        "name",
        "placeholder",
        "disabled",
        "readOnly",
        "autoFocus",
        "ariaLabel",
        "ariaRequired",
        "disableBrowserAutocorrect",
        "expandToViewport",
        "ariaControls",
        "ariaActivedescendant",
        "dropdownExpanded",
        "dropdownContentKey",
        "dropdownContentFocusable",
        "dropdownContent",
        "dropdownFooter",
        "dropdownWidth",
        "loopFocus",
        "onCloseDropdown",
        "onDelayedInput",
        "onPressArrowDown",
        "onPressArrowUp",
        "onPressEnter",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(restProps);
    var formFieldContext = (0,form_field_context/* useFormFieldContext */.e)(restProps);
    var inputRef = (0,react.useRef)(null);
    var dropdownContentRef = (0,react.useRef)(null);
    var dropdownFooterRef = (0,react.useRef)(null);
    var preventOpenOnFocusRef = (0,react.useRef)(false);
    var preventCloseOnBlurRef = (0,react.useRef)(false);
    var _g = (0,react.useState)(false), open = _g[0], setOpen = _g[1];
    var openDropdown = function() {
        return !readOnly && setOpen(true);
    };
    var closeDropdown = function() {
        setOpen(false);
        (0,events/* fireNonCancelableEvent */.B4)(onCloseDropdown, null);
    };
    (0,react.useImperativeHandle)(ref, function() {
        return {
            focus: function(options) {
                var _a;
                if (options === null || options === void 0 ? void 0 : options.preventDropdown) {
                    preventOpenOnFocusRef.current = true;
                }
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            select: function() {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
            },
            open: openDropdown,
            close: closeDropdown
        };
    });
    var handleBlur = function() {
        if (!preventCloseOnBlurRef.current) {
            closeDropdown();
            (0,events/* fireNonCancelableEvent */.B4)(onBlur, null);
        }
    };
    var handleFocus = function() {
        if (!preventOpenOnFocusRef.current) {
            openDropdown();
            (0,events/* fireNonCancelableEvent */.B4)(onFocus, null);
        }
        preventOpenOnFocusRef.current = false;
    };
    var handleKeyDown = function(e) {
        switch(e.detail.keyCode){
            case keycode/* KeyCode.down */.V.down:
                {
                    onPressArrowDown === null || onPressArrowDown === void 0 ? void 0 : onPressArrowDown();
                    openDropdown();
                    e.preventDefault();
                    break;
                }
            case keycode/* KeyCode.up */.V.up:
                {
                    onPressArrowUp === null || onPressArrowUp === void 0 ? void 0 : onPressArrowUp();
                    openDropdown();
                    e.preventDefault();
                    break;
                }
            case keycode/* KeyCode.enter */.V.enter:
                {
                    if (open) {
                        if (!(onPressEnter === null || onPressEnter === void 0 ? void 0 : onPressEnter())) {
                            closeDropdown();
                        }
                        e.preventDefault();
                    }
                    (0,events/* fireCancelableEvent */.y1)(onKeyDown, e.detail);
                    break;
                }
            case keycode/* KeyCode.escape */.V.escape:
                {
                    if (open) {
                        closeDropdown();
                    } else if (value) {
                        (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                            value: ""
                        });
                    }
                    e.preventDefault();
                    (0,events/* fireCancelableEvent */.y1)(onKeyDown, e.detail);
                    break;
                }
            default:
                {
                    (0,events/* fireCancelableEvent */.y1)(onKeyDown, e.detail);
                }
        }
    };
    var handleChange = function(value) {
        openDropdown();
        (0,events/* fireNonCancelableEvent */.B4)(onChange, {
            value: value
        });
    };
    var handleDelayedInput = function(value) {
        (0,events/* fireNonCancelableEvent */.B4)(onDelayedInput, {
            value: value
        });
    };
    var handleDropdownMouseDown = function(event) {
        // Prevent currently focused element from losing focus.
        if (!dropdownContentFocusable) {
            event.preventDefault();
        } else {
            preventCloseOnBlurRef.current = true;
            requestAnimationFrame(function() {
                preventCloseOnBlurRef.current = false;
            });
        }
    };
    var expanded = open && dropdownExpanded;
    var nativeAttributes = {
        name: name,
        placeholder: placeholder,
        autoFocus: autoFocus,
        onClick: openDropdown,
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-expanded": expanded,
        "aria-controls": open ? ariaControls : undefined,
        // 'aria-owns' needed for safari+vo to announce activedescendant content
        "aria-owns": open ? ariaControls : undefined,
        "aria-label": ariaLabel,
        "aria-activedescendant": ariaActivedescendant
    };
    // Closes dropdown when outside click is detected.
    // Similar to the internal dropdown implementation but includes the target as well.
    (0,react.useEffect)(function() {
        if (!open) {
            return;
        }
        var clickListener = function(event) {
            var _a, _b, _c;
            if (!((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) && !((_b = dropdownContentRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)) && !((_c = dropdownFooterRef.current) === null || _c === void 0 ? void 0 : _c.contains(event.target))) {
                closeDropdown();
            }
        };
        window.addEventListener("mousedown", clickListener);
        return function() {
            window.removeEventListener("mousedown", clickListener);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, autosuggest_input_styles_css.root),
        ref: __internalRootRef
    }), /*#__PURE__*/ react.createElement(dropdown/* default */.Z, {
        minWidth: dropdownWidth,
        stretchWidth: !dropdownWidth,
        contentKey: dropdownContentKey,
        onFocus: handleFocus,
        onBlur: handleBlur,
        trigger: /*#__PURE__*/ react.createElement(internal/* default */.Z, (0,tslib_es6/* __assign */.pi)({
            type: "visualSearch",
            value: value,
            onChange: function(event) {
                return handleChange(event.detail.value);
            },
            __onDelayedInput: function(event) {
                return handleDelayedInput(event.detail.value);
            },
            onKeyDown: handleKeyDown,
            onKeyUp: onKeyUp,
            disabled: disabled,
            disableBrowserAutocorrect: disableBrowserAutocorrect,
            readOnly: readOnly,
            ariaRequired: ariaRequired,
            ref: inputRef,
            autoComplete: false,
            __nativeAttributes: nativeAttributes
        }, formFieldContext)),
        onMouseDown: handleDropdownMouseDown,
        open: open,
        footer: dropdownFooterRef && /*#__PURE__*/ react.createElement("div", {
            ref: dropdownFooterRef,
            className: autosuggest_input_styles_css["dropdown-footer"]
        }, dropdownFooter),
        expandToViewport: expandToViewport,
        loopFocus: loopFocus
    }, open && dropdownContent ? /*#__PURE__*/ react.createElement("div", {
        ref: dropdownContentRef,
        className: autosuggest_input_styles_css["dropdown-content"]
    }, dropdownContent) : null));
});
/* harmony default export */ var autosuggest_input = (AutosuggestInput); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/internal.js
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0















var InternalAutosuggest = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var _a;
    var value = props.value, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, onKeyUp = props.onKeyUp, onLoadItems = props.onLoadItems, options = props.options, _b = props.filteringType, filteringType = _b === void 0 ? "auto" : _b, _c = props.statusType, statusType = _c === void 0 ? "finished" : _c, recoveryText = props.recoveryText, placeholder = props.placeholder, name = props.name, disabled = props.disabled, _d = props.disableBrowserAutocorrect, disableBrowserAutocorrect = _d === void 0 ? false : _d, autoFocus = props.autoFocus, readOnly = props.readOnly, ariaLabel = props.ariaLabel, ariaRequired = props.ariaRequired, enteredTextLabel = props.enteredTextLabel, onKeyDown = props.onKeyDown, virtualScroll = props.virtualScroll, expandToViewport = props.expandToViewport, onSelect = props.onSelect, selectedAriaLabel = props.selectedAriaLabel, renderHighlightedAriaLive = props.renderHighlightedAriaLive, __internalRootRef = props.__internalRootRef, restProps = (0,tslib_es6/* __rest */._T)(props, [
        "value",
        "onChange",
        "onBlur",
        "onFocus",
        "onKeyUp",
        "onLoadItems",
        "options",
        "filteringType",
        "statusType",
        "recoveryText",
        "placeholder",
        "name",
        "disabled",
        "disableBrowserAutocorrect",
        "autoFocus",
        "readOnly",
        "ariaLabel",
        "ariaRequired",
        "enteredTextLabel",
        "onKeyDown",
        "virtualScroll",
        "expandToViewport",
        "onSelect",
        "selectedAriaLabel",
        "renderHighlightedAriaLive",
        "__internalRootRef"
    ]);
    (0,check_controlled/* default */.Z)("Autosuggest", "value", value, "onChange", onChange);
    (0,check_option_value_field/* checkOptionValueField */.N)("Autosuggest", "options", options);
    var autosuggestInputRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            focus: function() {
                var _a;
                return (_a = autosuggestInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            select: function() {
                var _a;
                return (_a = autosuggestInputRef.current) === null || _a === void 0 ? void 0 : _a.select();
            }
        };
    }, []);
    var _e = useAutosuggestItems({
        options: options || [],
        filterValue: value,
        filterText: value,
        filteringType: filteringType,
        hideEnteredTextLabel: false,
        onSelectItem: function(option) {
            var _a;
            var value = option.value || "";
            (0,events/* fireNonCancelableEvent */.B4)(onChange, {
                value: value
            });
            (0,events/* fireNonCancelableEvent */.B4)(onSelect, {
                value: value
            });
            (_a = autosuggestInputRef.current) === null || _a === void 0 ? void 0 : _a.close();
        }
    }), autosuggestItemsState = _e[0], autosuggestItemsHandlers = _e[1];
    var autosuggestLoadMoreHandlers = useAutosuggestLoadMore({
        options: options,
        statusType: statusType,
        onLoadItems: function(detail) {
            return (0,events/* fireNonCancelableEvent */.B4)(onLoadItems, detail);
        }
    });
    var handleChange = function(event) {
        autosuggestItemsHandlers.setShowAll(false);
        autosuggestItemsHandlers.resetHighlightWithKeyboard();
        (0,events/* fireNonCancelableEvent */.B4)(onChange, event.detail);
    };
    var handleDelayedInput = function(event) {
        autosuggestLoadMoreHandlers.fireLoadMoreOnInputChange(event.detail.value);
    };
    var handleBlur = function() {
        (0,events/* fireNonCancelableEvent */.B4)(onBlur, null);
    };
    var handleFocus = function() {
        autosuggestItemsHandlers.setShowAll(true);
        autosuggestLoadMoreHandlers.fireLoadMoreOnInputFocus();
        (0,events/* fireNonCancelableEvent */.B4)(onFocus, null);
    };
    var handleKeyUp = function(e) {
        (0,events/* fireCancelableEvent */.y1)(onKeyUp, e.detail);
    };
    var handleKeyDown = function(e) {
        (0,events/* fireCancelableEvent */.y1)(onKeyDown, e.detail);
    };
    var handlePressArrowDown = function() {
        autosuggestItemsHandlers.moveHighlightWithKeyboard(1);
    };
    var handlePressArrowUp = function() {
        autosuggestItemsHandlers.moveHighlightWithKeyboard(-1);
    };
    var handlePressEnter = function() {
        return autosuggestItemsHandlers.selectHighlightedOptionWithKeyboard();
    };
    var handleCloseDropdown = function() {
        autosuggestItemsHandlers.resetHighlightWithKeyboard();
    };
    var handleRecoveryClick = function() {
        var _a;
        autosuggestLoadMoreHandlers.fireLoadMoreOnRecoveryClick();
        (_a = autosuggestInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var formFieldContext = (0,form_field_context/* useFormFieldContext */.e)(restProps);
    var selfControlId = (0,use_unique_id/* useUniqueId */.L)("input");
    var controlId = (_a = formFieldContext.controlId) !== null && _a !== void 0 ? _a : selfControlId;
    var listId = (0,use_unique_id/* useUniqueId */.L)("list");
    var highlightedOptionId = autosuggestItemsState.highlightedOption ? (0,use_unique_id/* generateUniqueId */.l)() : undefined;
    var isEmpty = !value && !autosuggestItemsState.items.length;
    var dropdownStatus = (0,dropdown_status/* useDropdownStatus */.w)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, props), {
        isEmpty: isEmpty,
        recoveryText: recoveryText,
        onRecoveryClick: handleRecoveryClick
    }));
    return /*#__PURE__*/ react.createElement(autosuggest_input, (0,tslib_es6/* __assign */.pi)({}, restProps, {
        className: (0,clsx_m/* default */.Z)(styles_css.root, restProps.className),
        ref: autosuggestInputRef,
        __internalRootRef: __internalRootRef,
        value: value,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onKeyUp: handleKeyUp,
        onKeyDown: handleKeyDown,
        name: name,
        controlId: controlId,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaRequired: ariaRequired,
        disableBrowserAutocorrect: disableBrowserAutocorrect,
        expandToViewport: expandToViewport,
        ariaControls: listId,
        ariaActivedescendant: highlightedOptionId,
        dropdownExpanded: autosuggestItemsState.items.length > 1 || dropdownStatus.content !== null,
        dropdownContent: /*#__PURE__*/ react.createElement(AutosuggestOptionsList, {
            autosuggestItemsState: autosuggestItemsState,
            autosuggestItemsHandlers: autosuggestItemsHandlers,
            highlightedOptionId: highlightedOptionId,
            highlightText: value,
            listId: listId,
            controlId: controlId,
            enteredTextLabel: enteredTextLabel,
            handleLoadMore: autosuggestLoadMoreHandlers.fireLoadMoreOnScroll,
            hasDropdownStatus: dropdownStatus.content !== null,
            virtualScroll: virtualScroll,
            selectedAriaLabel: selectedAriaLabel,
            renderHighlightedAriaLive: renderHighlightedAriaLive,
            listBottom: !dropdownStatus.isSticky ? /*#__PURE__*/ react.createElement(dropdown_footer/* default */.Z, {
                content: dropdownStatus.content
            }) : null
        }),
        dropdownFooter: dropdownStatus.isSticky ? /*#__PURE__*/ react.createElement(dropdown_footer/* default */.Z, {
            content: dropdownStatus.content,
            hasItems: autosuggestItemsState.items.length >= 1
        }) : null,
        loopFocus: statusType === "error" && !!recoveryText,
        onCloseDropdown: handleCloseDropdown,
        onDelayedInput: handleDelayedInput,
        onPressArrowDown: handlePressArrowDown,
        onPressArrowUp: handlePressArrowUp,
        onPressEnter: handlePressEnter
    }));
});
/* harmony default export */ var autosuggest_internal = (InternalAutosuggest); //# sourceMappingURL=internal.js.map

// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/external-props.js
var external_props = __webpack_require__(6464);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/utils/apply-display-name.js
var apply_display_name = __webpack_require__(1651);
// EXTERNAL MODULE: ./packages/fire-theme/dist/components/internal/hooks/use-base-component/index.js + 2 modules
var use_base_component = __webpack_require__(4656);
;// CONCATENATED MODULE: ./packages/fire-theme/dist/components/autosuggest/index.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





var Autosuggest = /*#__PURE__*/ react.forwardRef(function(_a, ref) {
    var _b = _a.filteringType, filteringType = _b === void 0 ? "auto" : _b, _c = _a.statusType, statusType = _c === void 0 ? "finished" : _c, _d = _a.disableBrowserAutocorrect, disableBrowserAutocorrect = _d === void 0 ? false : _d, props = (0,tslib_es6/* __rest */._T)(_a, [
        "filteringType",
        "statusType",
        "disableBrowserAutocorrect"
    ]);
    var baseComponentProps = (0,use_base_component/* default */.Z)("Autosuggest");
    var externalProps = (0,external_props/* getExternalProps */.x)(props);
    return /*#__PURE__*/ react.createElement(autosuggest_internal, (0,tslib_es6/* __assign */.pi)({
        filteringType: filteringType,
        statusType: statusType,
        disableBrowserAutocorrect: disableBrowserAutocorrect
    }, externalProps, baseComponentProps, {
        ref: ref
    }));
});
(0,apply_display_name/* applyDisplayName */.b)(Autosuggest, "Autosuggest");
/* harmony default export */ var autosuggest = (Autosuggest); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 8241:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3426:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);